export type AnalyticsCheckoutStep = {
  step: number;
  option?: string;
};
